var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06715 4.72054C2.59917 4.72054 2.21981 5.09991 2.21981 5.56788V14.8116C2.21981 15.2795 2.59917 15.6589 3.06715 15.6589H16.9327C17.4007 15.6589 17.78 15.2795 17.78 14.8116V5.56788C17.78 5.09991 17.4007 4.72054 16.9327 4.72054H3.06715ZM0.833252 5.56788C0.833252 4.33413 1.8334 3.33398 3.06715 3.33398H16.9327C18.1664 3.33398 19.1666 4.33413 19.1666 5.56788V14.8116C19.1666 16.0453 18.1664 17.0455 16.9327 17.0455H3.06715C1.8334 17.0455 0.833252 16.0453 0.833252 14.8116V5.56788Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 8.64835C0.833252 8.26547 1.14364 7.95508 1.52653 7.95508H18.4733C18.8562 7.95508 19.1666 8.26547 19.1666 8.64835C19.1666 9.03124 18.8562 9.34163 18.4733 9.34163H1.52653C1.14364 9.34163 0.833252 9.03124 0.833252 8.64835Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.79073082b023e56f884b4a646515e110.svg";
export { ForwardRef as ReactComponent };